import { Star } from 'lucide-react';
import styles from './StarRating.module.css';

interface Props {
  rating: number;
  size?: number;
}

export function StarRating({ rating, size = 15 }: Props) {
  return (
    <span className={styles.stars} aria-label={`${rating} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          size={size}
          className={n <= rating ? styles.filled : styles.empty}
          fill={n <= rating ? 'currentColor' : 'none'}
          aria-hidden
        />
      ))}
    </span>
  );
}
